import ENTITY_DATA from "../../../../data/index.js";
import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { id, form, submitBtn } = data;
        const fileURL = APP_COMPONENTS.fileForms.getURL(id);
        if (!fileURL) {
            APP_COMPONENTS.fileError.show('INCOMPLETE', 'Please upload an avatar before submitting.');
            return;
        }
        const payload = {
            name: form.fullname.value.trim(),
            quote: form.quote.value.trim(),
            avatar: fileURL,
            orderIndex: ENTITY_DATA.getAll().length
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/testimonials/create', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Testimonial added successfully.`
            });
            APP_COMPONENTS.testimonialForms.update(id, response.id);
            APP_COMPONENTS.fileForms.update(id, form, response.id);
            ENTITY_DATA.add({ id: response.id, title: response.title });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
